<template>
  <div>
    <CampaignBudget />
    <hr class="divider" />
    <CampaignDailyCap />
  </div>
</template>

<script>
import CampaignBudget from './CampaignBudget';
import CampaignDailyCap from './CampaignDailyCap';

export default {
  name: 'CampaignFinance',
  components: {
    CampaignBudget,
    CampaignDailyCap,
  },
};
</script>
